import React from 'react';
import Header from './../../Header';
import Footer from './../../Footer';
import Menu from './../../Menu';
import Loader from './../../Loader';
import JournalNav from './../JournalNav';
import RecentJournals from './RecentJournals';
import { fetchMenu } from "./../../../actions/menuActionCreators";
import { fetchJournals } from "./../../../actions/journalActionCreators";
import { fetchOptions } from "./../../../actions/optionActionCreators";
import ScrollNav from './../../ScrollNav';
import { Helmet } from 'react-helmet';
import ReactHtmlParser from 'react-html-parser';
import {
    NavLink,
    Link
} from 'react-router-dom'
import RecentProjects from '../../Home/RecentProjects';
import Layout from './Layouts';

import ReactGA from 'react-ga';
class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true,
            seo: false
        }
    }
    componentDidMount() {
        let {slug} = this.props.match.params;
        ReactGA.pageview('/journal/'+slug);
        let _this = this;
        Promise.all([
            this.props.dispatch(fetchMenu('menu')),
            this.props.dispatch(fetchJournals()),
            this.props.dispatch(fetchOptions()),
            fetch(process.env.REACT_APP_API_URL+'yoast/v1/get_head?url='+process.env.REACT_APP_WP_URL+'lelay_journals/'+slug+'/')
                .then(response => response.json())
                .then(json => {
                    _this.setState((prevState) => ({
                        ...prevState,
                        seo: json.head
                    }))
                })
        ]).then(() => {
            this.setState({
                pageLoading: false
            })
        });
    }

    render() {
		let { menu } = this.props.menu;
        let _this = this;
        let journals = this.props.journals && Object.keys(this.props.journals.data).length ? this.props.journals.data.all : [];
        let recent_journals = this.props.journals && Object.keys(this.props.journals.data).length ? this.props.journals.data.recent : [];
        let details_slug = this.props.match.params.slug;
        let journalList = journals.filter((item) => {
            return item.post_name == details_slug;
        });

        if (journalList[0] === undefined) return [];

        let related_journals_arr = journalList[0].related_journals;
        let related_journals = [];

        if(related_journals_arr){
            if(related_journals_arr instanceof Array){
                related_journals = journals.filter((item) => {
                    return related_journals_arr.indexOf( item.ID ) >= 0;
                });
            }else{
                related_journals = journals.filter((item) => {
                    return Number(item.ID) === Number(related_journals_arr);
                });
            }
        }
        
        let layoutData = journalList[0].layout.map((row, index) => {
            return (<div dangerouslySetInnerHTML={{ __html: row }} key={index} />)
        })
        return (
			<div className="fullW">
                 {
                    this.state.seo &&
                    <Helmet>
                        {ReactHtmlParser(this.state.seo)}
                    </Helmet>
                }
                <Header {...this.props} />
                    <main className="ll__journal">
                        {this.state.pageLoading &&
                            <Loader />
                        }
                        <section>
                            <div class="main-container">
                                <JournalNav />
                                <div class="ll__journal--dtls">
                                    <span class="date">{journalList[0].formatted_date}</span>
                                    <h3 class="journal-title">{journalList[0].post_title}</h3>
                                    {journalList[0].sections == null &&
                                        layoutData
                                    }
                                    {journalList[0].sections != null &&
                                        <Layout  {..._this.props} details={journalList[0]} />
                                    }
                                </div>
                                <RecentJournals {..._this.props} related_journals={related_journals} types={this.props.journals.data.types} />
                            </div>
                        </section>
                    </main>
                {menu.primary &&
                    <Menu {...this.props} />
                }
                <Footer {...this.props} />
                <ScrollNav/>
            </div>
        );
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Journals/Details/index.js